const STORAGE_KEY = "usage.includeLlmDetail";

/**
 * The SuperAdmin's "engineering detail" switch, persisted.
 *
 * The switch itself lives in `UsageToolbar`. Only the preference is here,
 * because two screens own the control and both must read the same key.
 *
 * **SuperAdmin surfaces only.** The tenant routes do not accept the query
 * parameter and their response models have no field for the answer, so a
 * switch on `/admin/usage` would be a control with nothing behind it.
 *
 * Defaults to off — the narrow view is the norm.
 */
export const readEngineeringDetailPreference = () => {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    // Private mode, or storage disabled. Not worth failing a page over.
    return false;
  }
};

export const writeEngineeringDetailPreference = (value) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, String(!!value));
  } catch {
    // Same reasoning — the switch still works for this session.
  }
};
